<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <div class="header-grid" :class="'agents_' + _uid">
      <div
        v-for="item in items"
        :id="item.value"
        :key="item.value"
        class="draggable-column item"
        :class="itemClass(item)"
      >
        <div class="item-content header-item d-flex flex-row align-center">
          {{ $t(item.text) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Muuri from 'muuri';

export default {
  name: 'EcsHeaderReorder',
  props: {
    headers: {
      type: Array,
      required: true
    },
    tab: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      grid: null,
      offTabAcc: []
    };
  },
  computed: {
    items() {
      return this.headers.filter(header => header.value !== 'agentName');
    },
    itemVisibilityClass() {
      return this.headers.map(header => {
        return { columnIndex: header.columnIndex, show: header.show };
      });
    }
  },
  watch: {
    itemVisibilityClass: {
      handler(after, before) {
        after.find((obj, index) => {
          if (obj.show !== before[index].show) {
            const item = this.grid.getItems().filter(function(item) {
              return item._element._prevClass.includes(' index-' + obj.columnIndex + ' ');
            })[0];

            const indexOfItem = this.offTabAcc.indexOf(item);
            if (indexOfItem === -1) {
              this.offTabAcc.push(item);
            }
          }
        });
      },
      deep: true
    },
    async tab(newValue) {
      if (!this.grid && newValue === 1) {
        this.initializeGrid();
      }

      await this.$nextTick();
      if (this.offTabAcc.length > 0) {
        const hideItems = this.offTabAcc.filter(item => item._element._prevClass.includes('hide'));
        const showItems = this.offTabAcc.filter(item => item._element._prevClass.includes('show'));
        if (hideItems.length > 0) {
          this.grid.hide(hideItems);
        }
        if (showItems.length > 0) {
          this.grid.show(showItems);
        }
        this.offTabAcc = [];
      }
    }
  },
  mounted() {
    this.initializeGrid();
    const allItems = this.grid.getItems().filter(function(item) {
      return item._element._prevClass.includes('hide');
    });
    this.grid.hide(allItems);
  },
  beforeDestroy() {
    if (this.grid) {
      this.grid.off('dragEnd', this.onDragEnd);
      this.grid.destroy(true);
    }
  },
  methods: {
    itemClass(item) {
      const itemIndex = 'index-' + item.columnIndex + ' ';
      return itemIndex + (!item.show ? 'hide' : 'show');
    },
    initializeGrid() {
      if (this.grid) {
        return;
      }
      this.grid = new Muuri('.header-grid.agents_' + this._uid, {
        dragEnabled: true,
        dragHandle: '.draggable-column',
        dragAxis: 'xy',
        items: '.item',
        layout: this.createWindowsCustomLayout
      });
      this.grid.layout();
      this.grid.on('dragEnd', this.onDragEnd);
    },
    createWindowsCustomLayout(grid, layoutId, items, width, height, callback) {
      const layout = {
        id: layoutId,
        items,
        slots: [],
        styles: {}
      };
      grid.refreshItems();
      let item;
      let m;
      let x = 0;
      let y = 0;
      let w = 0;
      let h = 0;

      for (let i = 0; i < items.length; i++) {
        item = items[i];
        x += w;
        m = item.getMargin();
        w = item.getWidth() + m.left + m.right;
        h = item.getHeight() + m.top + m.bottom;
        const itemsOverflowsContainerWidth = width < x + w;
        if (itemsOverflowsContainerWidth) {
          x = 0;
          y += h;
        }
        layout.slots.push(x, y);
      }
      // Set the CSS styles that should be applied
      // to the grid element.
      layout.styles.width = `${w}px`;
      layout.styles.height = `${h}px`;

      // When the layout is fully computed
      // let's call the callback function and
      // provide the layout object as it's argument.
      callback(layout);
    },
    getMuuriItemsOrder() {
      return this.grid.getItems().map(item => item.getElement().getAttribute('id'));
    },
    onDragEnd() {
      const orderedCardsIds = this.getMuuriItemsOrder();
      this.$emit('onColumnReorder', ['agentName', ...orderedCardsIds]);
    }
  }
};
</script>

<style scoped>
.header-grid {
  position: relative;
  width: 100% !important;
  height: 120px;
}
.header-item {
  width: 70px;
  height: 50px;
  border-right: 1px solid #d3d3d3;
}
.item {
  display: block;
  position: absolute;
  margin: 5px;
  z-index: 1;
}
.item.muuri-item-dragging {
  z-index: 3;
}
.item.muuri-item-releasing {
  z-index: 2;
}
.item.muuri-item-hidden {
  z-index: 0;
}
.item-content {
  position: relative;
  width: 70px;
  height: 50px;
}
</style>
